import {createRouter, createWebHistory} from 'vue-router'
import users from "@/router/users";
import adminRoutes from "@/router/adminRoutes.js";
import HomePage from "@/systems/main/HomePage.vue";
import community from "@/systems/community/community.js";
import NotFoundView from "@/components/NotFoundView.vue";
import info from "@/info";
import AuthenticationView from "@/systems/main/AuthenticationView.vue";
import eventBus from "@/eventBus";

const routes = [
  {
    name: "home",
    path: "/home",
    component: HomePage
  },
  {
    name: "authentication",
    path: "/authentication",
    component: AuthenticationView
  },
  {
    path: "/:pathMatch(.*)*",
    component: NotFoundView
  },
];

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes
});

let requestedLoginPath = window.location.pathname + window.location.search;

router.beforeEach((to, from, next) => {
  if (info.user && to.name === "authentication") {
    next({ name: "home" });
    return;
  }
  if (to.name === "authentication") {
    next();
    return;
  }
  if (Object.keys(info.global).length === 0) return;
  if (info.user || to.name === "authentication") {
    next();
  } else {
    next({ name: "authentication" });
  }
});

eventBus.on("info.global.loaded", () => {
  if (!info.user) router.push("/");
});

eventBus.on("login", () => {
  router.addRoute({
    name: "root",
    path: "/",
    redirect: { name: "home" },
    children: [
      ...community.getRoutes(),
      ...users,
      ...adminRoutes,
    ]
  });
  if (requestedLoginPath !== undefined && router.resolve({ path: requestedLoginPath })?.name !== "authentication") {
    router.push(requestedLoginPath);
  } else {
    router.push("/");
  }
  requestedLoginPath = undefined;
});

eventBus.on("logout", () => {
  router.removeRoute("root");
});

export default router
